<style scoped>

</style>
<template>
  <div class="error-page"></div>
</template>
<script>
export default {
  created: function () {
    const vm = this;
    if (vm.$route.query) {
      vm.$LoadingBar.start();

      R.Public.DownloadListaArquivosStorage(vm.$route.query).then(resp => {
        if (!resp) {
          vm.$LoadingBar.fail();
          return false;
        }
        if (resp._response.status == 410) {
          vm.$LoadingBar.fail();
          vm.$router.push({ name: 'ArquivoIndisponivel' });
        } else {
          vm.$LoadingBar.success();
          vm.$router.push({ name: 'DownloadConcluido' });
        }
      });
    }
  }
};
</script>
